import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as Api from '../../utils/api/api.js';
import _ from "lodash";
import Select from '../common/select/Select.component.tsx';

export default class EmailInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: true,
            emails: [],
            selectedEmail: null,
            isLoading: false,
            inputValue: '',
        };
        this.selectInputRef = React.createRef();
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getEmails = this.getEmails.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.focus = this.focus.bind(this);
        this.delayEmail = _.debounce((data) => this.getEmails(data), 700);
    }

    componentWillUnmount() {
        this.delayEmail.cancel();
    }

    onBlur() {
        // Check if there's a selected option first
        if (this.state.selectedEmail) {
            const email = this.state.selectedEmail.value || this.state.selectedEmail;
            this.validateEmail(email);
            this.props.propagateValue(email);
        }
        // If no selected option but there's input value, treat it as custom email
        else if (this.state.inputValue?.trim()) {
            const email = this.state.inputValue.trim();
            const isValid = this.validateEmail(email);
            if (isValid) {
                // Create a custom option for the manually entered email
                const customOption = {
                    label: email,
                    value: email
                };
                this.setState({ selectedEmail: customOption });
                this.props.propagateValue(email);
            }
        }
    }

    validateEmail(email) {
        let isValid = true;
        let regExp = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
        if (!regExp.test(email)) {
            isValid = false;
        }
        this.setState({
            isValid: isValid
        });
        return isValid;
    }

    getEmails(input) {
        if (!input) {
            this.delayEmail.cancel(); // Cancel any pending debounced calls
            this.setState({ emails: [], isLoading: false });
            return;
        }

        this.setState({ isLoading: true });

        return Api.getUserEmails(input, true).then(response => {
            let results = [];
            response.forEach(item => {
                results.push({
                    label: item.email,
                    value: item.email
                });
            });
            this.setState({
                emails: results,
                isLoading: false
            });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    }

    onChange(selectedOption) {
        this.setState({
            selectedEmail: selectedOption,
            isValid: true
        });

        const email = selectedOption ? selectedOption.value : null;
        if (email) {
            this.validateEmail(email);
            this.props.propagateValue(email);
        } else {
            this.props.propagateValue(null);
        }
    }

    onInputChange(inputValue) {
        this.setState({ inputValue });
        this.delayEmail(inputValue);
    }

    focus() {
        this.selectInputRef.current?.focus();
    }

    render() {
        const { isValid, selectedEmail, emails, isLoading } = this.state;

        return (
            <div className={this.props.className}>
                <Select
                    ref={this.selectInputRef}
                    options={emails}
                    value={selectedEmail}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    onInputChange={this.onInputChange}
                    placeholder={this.props.translate("popUp.email.emailPlaceholder")}
                    isSearchable={true}
                    isClearable={true}
                    isLoading={isLoading}
                    invalid={!isValid}
                    tabIndex={this.props.tabIndex}
                    autoFocus={this.props.autoFocus}
                    showNoOptions={false}
                    translate={this.props.translate}
                />

            </div>
        );
    }
}

EmailInput.propTypes = {
    translate: PropTypes.func, // to translate texts
    propagateValue: PropTypes.func, // callback to propage value to parent
    className: PropTypes.string, // class for the wrapper div
    tabIndex: PropTypes.number, // tab index for the input
    autoFocus: PropTypes.bool // whether to auto focus the input on mount
};

// EmailInput.defaultProps = {
//     value: ''
// }
